// https://www.figma.com/file/O0FWE4TJWmIGCksbLUEL0i0y/%E2%9D%96-Web-Component-Library?node-id=4447%3A1249

export const breakpoints = {
  xxs: '20em',
  xs: '23.5em',
  s: '48em',
  m: '64em',
  l: '85.375em',
  xl: '100em',
  '2xl': '120em',
} as const;
